// Configuración de la API según el entorno
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://api.imageclec.cl'
  : 'http://localhost:5000'; // Backend corre en puerto 5000 según application.properties

export const API_ENDPOINTS = {
  // Endpoints existentes
  contact: `${API_BASE_URL}/api/contact`,
  health: `${API_BASE_URL}/api/health`,

  // Endpoints de autenticación
  login: `${API_BASE_URL}/api/auth/login`,
  register: `${API_BASE_URL}/api/auth/register`,
  logout: `${API_BASE_URL}/api/auth/logout`,
  changePassword: `${API_BASE_URL}/api/auth/change-password`,
  forgotPassword: `${API_BASE_URL}/api/auth/forgot-password`,
  resetPassword: `${API_BASE_URL}/api/auth/reset-password`,
  validateResetToken: (token: string) => `${API_BASE_URL}/api/auth/validate-reset-token/${token}`,

  // Endpoints de perfil
  profile: `${API_BASE_URL}/api/profile`,

  // Endpoints de documentos
  documents: `${API_BASE_URL}/api/documents`,

  // Endpoints de facturas
  invoices: `${API_BASE_URL}/api/invoices`,

  // Endpoints de usuarios (Admin)
  users: `${API_BASE_URL}/api/users`,
  userById: (id: number) => `${API_BASE_URL}/api/users/${id}`,

  // Endpoints de invitaciones
  createInvitation: `${API_BASE_URL}/api/invitations`,
  validateInvitation: (token: string) => `${API_BASE_URL}/api/invitations/validate?token=${encodeURIComponent(token)}`,
  completeRegistration: `${API_BASE_URL}/api/invitations/register`
};

export default API_BASE_URL;